import { jsx as _jsx } from "react/jsx-runtime";
import useGiveawayStore from '@/stores/GiveawayStore';
import React from 'react';
import { useShallow } from 'zustand/react/shallow';
import SettingsPanel from '../SettingsPanel';
import { useIntl } from 'react-intl';
import { Switch } from '@mantine/core';
import styles from './GiveawayWinnerMessageSetting.module.scss';
export default function GiveawayWinnerMessageSetting() {
    var intl = useIntl();
    var _useGiveawayStore = useGiveawayStore(useShallow(function(state) {
        return {
            shouldSendWinnerMessage: state.shouldSendWinnerMessage,
            setShouldSendWinnerMessage: state.setShouldSendWinnerMessage
        };
    })), shouldSendWinnerMessage = _useGiveawayStore.shouldSendWinnerMessage, setShouldSendWinnerMessage = _useGiveawayStore.setShouldSendWinnerMessage;
    return /*#__PURE__*/ _jsx(SettingsPanel, {
        className: styles.settingsPanel,
        heading: intl.formatMessage({
            id: "rX3chn",
            defaultMessage: [
                {
                    type: 0,
                    value: "Chat Announcement"
                }
            ]
        }),
        afterElement: /*#__PURE__*/ _jsx(Switch, {
            checked: shouldSendWinnerMessage,
            onChange: function(e) {
                return setShouldSendWinnerMessage(e.target.checked);
            }
        })
    });
}
